/**
 * Page Access Configuration
 * Defines which roles can access specific pages
 */

import { GlobalRole, OrgRole } from '../services/util.enum';

export interface PageRoleConfig {
  allowedRoles: (GlobalRole | OrgRole)[];
}

export const PAGE_ROLES: Record<string, PageRoleConfig> = {
  // manageusers: Global Admin ✓, Global Viewer ✓, Org Admin ✓, Restricted Roles ✗
  manageusers: {
    allowedRoles: [GlobalRole.DEV_ADMIN, GlobalRole.SYS_ADMIN, GlobalRole.DEV_VIEWER, OrgRole.ORG_ADMIN]
  },

  // manageorgs: Global Admin ✓, Global Viewer ✓, Org Admin ✗, Restricted Roles ✗
  manageorgs: {
    allowedRoles: [GlobalRole.DEV_ADMIN, GlobalRole.SYS_ADMIN, GlobalRole.DEV_VIEWER]
  },

  // getOrgDetail: Global Admin ✓, Global Viewer ✓, Org Admin ✓, Restricted Roles ✗
  getOrgDetail: {
    allowedRoles: [GlobalRole.DEV_ADMIN, GlobalRole.SYS_ADMIN, GlobalRole.DEV_VIEWER, OrgRole.ORG_ADMIN]
  }
};
